import i18n from "~/i18n";

interface User {
  firstName: string;
  lastName?: string;
}

export const printFullName = (user?: User | null, isMe?: boolean) => {
  if (!user) {
    return "";
  }

  let fullName = user.firstName;

  if (user.lastName) {
    fullName += ` ${user.lastName}`;
  }

  if (isMe) {
    fullName += ` (${i18n.t(($) => $.commons.workflow.you)})`;
  }

  return fullName;
};

export const currentUserAtTopCompareFn = (
  idA: number,
  idB: number,
  currentUserId: number,
) => (idB === currentUserId ? 1 : 0) - (idA === currentUserId ? 1 : 0);
